import { render, staticRenderFns } from "./Area1.vue?vue&type=template&id=71d86f68&scoped=true&"
import script from "./Area1.vue?vue&type=script&lang=js&"
export * from "./Area1.vue?vue&type=script&lang=js&"
import style0 from "./Area1.vue?vue&type=style&index=0&id=71d86f68&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d86f68",
  null
  
)

export default component.exports